module.exports = __webpack_public_path__ + "static/img/promoted_icon.df08960f.png";